import './VariableBlock.css';
import VariableDropdown from '../../../Variables/VariablesDropdown/VariablesDropdown';
import InputBox from '/src/components/UI/InputBox/InputBox';
import TextareaAutosize from 'react-textarea-autosize';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import SttConfig from '../SttConfig/SttConfig';
import TtsConfig from '../TtsConfig/TtsConfig';
import { useState, useRef, useEffect } from "react";

function VariableBlock ({block_id, first, id, idx, index, is_operation, value, variable, setValue, deleteValue, errors, setValueState, isOpen, move}) {

    const [open, setOpen] = useState(isOpen && (value == '' && variable == null && is_operation == false));
    const [currentHeight, setCurrentHeight] = useState(0);
    const [variableValue, setVariableValue] = useState(value);
    const [currentVariable, setCurrentVariable] = useState(variable);
    const refEditArea = useRef();

    const [isHover, setIsHover] = useState(false);
    const error = errors.filter(error => error[1].index == index).pop();

    const indexNumber = parseInt(index, 10);
    
    const getHeight = () => {
        const el = document.getElementsByClassName('measuring').item(index);
        return el ? el.clientHeight : 0;
    }

    const onToggle = () => {
        setOpen(prevOpen => {
            let newOpen = !prevOpen;
            setCurrentHeight(newOpen ? getHeight() : 0);
            return newOpen;
        });

        if(!open == false) {
            setCurrentHeight(0)
        }
        else {
            setCurrentHeight(getHeight())
        }
    }

    const onHeightChange = () => {
        if(currentHeight == 0) {
            return 0
        }
        setCurrentHeight(getHeight())
    }

    const disableSpellCheck = (ref) => {
        if(!ref) {
            return;
        }
        ref.spellcheck = false
    }

    const setValueVariable = (name, value) => {
        if (name === 'variable') {
            setCurrentVariable(value);
        }
        setValue(index, name, value)
    }

    const setValueCurrentStateAndTreeState = (name, value) => {
        setValueState(index, name, value)
    }

    useEffect(() => {
        if(open == false) {
            return;
        } 
        const newHeight = getHeight() + (error ? 14 : 0);
        if (newHeight !== currentHeight) {
            setCurrentHeight(newHeight);
        }
    }, [error, open]);
    useEffect(() => {
        if(refEditArea == null) {
            return;
        }

        if(first) {
            setOpen(true);
            setCurrentHeight(getHeight())
        }

        return () => {}
    }, [refEditArea])

    const classNameDropdown = open ? 'variables-contain' : 'variables-contain disabled';

    var classNameInput = 'input editor-input title_input';
    classNameInput = error ? classNameInput + ' error' : classNameInput;

    const isSttVariable = currentVariable?.type?.name === 'stt';
    const isTtsVariable = currentVariable?.type?.name === 'tts';
    const isSpecialVariable = isSttVariable || isTtsVariable;

    return (
        <>
            <div className="variable_block" onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                    <div style={{ width : '250px'}}>
                    <VariableDropdown className={classNameDropdown} variable={currentVariable} setValue={setValueVariable} name='variable' width="250px"/>
                    </div>
                <div className="actions">
                    {(isHover && idx != 0 && first != true) && <IconButton onClick={() => move(indexNumber, indexNumber - 1)} className="editor-iconButton main_add-button button_center profil_action" icon="fas fa-chevron-up"></IconButton>}
                    { (isHover && idx != - 1) && <IconButton onClick={() => move(indexNumber, indexNumber + 1)} className="editor-iconButton main_add-button button_center profil_action" icon="fas fa-chevron-down"></IconButton>}
                    {!isSpecialVariable && <IconButton onClick={onToggle} className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-edit"></IconButton>}
                    {(idx == 0 && parseInt(index, 10) == 0 || first == false) && <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={() => deleteValue(index)}></IconButton>}
                </div>
            </div>
            {isSttVariable ? (
                <SttConfig value={value} onChange={(jsonStr) => setValueVariable('value', jsonStr)} />
            ) : isTtsVariable ? (
                <TtsConfig value={value} onChange={(jsonStr) => setValueVariable('value', jsonStr)} />
            ) : (
                <div className={open ? "variable_zone_edit show" : "variable_zone_edit" } ref={refEditArea} style={{height : currentHeight}}>
                    <div className="measuring">
                        <div style={{ margin : '0 12px'}}>
                            <label className="dropdown_title" style={{ marginRight : '10px'}}>Calcul Operation : </label>
                            <InputBox id={`is_operation_${index}`} name='is_operation' check={is_operation} setValue={setValueVariable}/>
                        </div>
                        <div className="container-textarea">
                            <TextareaAutosize ref={(ref) => disableSpellCheck(ref)} value={value} onBlur={() => setValueVariable('value', value)} onChange={(e) => setValueCurrentStateAndTreeState('value', e.target.value)} onHeightChange={onHeightChange} className={classNameInput} placeholder='Enter a value' minRows={3}/>
                            {error ? <span className='error'>{error[1].data}</span> : ''}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

VariableBlock.defaultProps = {
    isOpen : false
}

export default VariableBlock